import React, { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { motion } from 'framer-motion';
import BoxedContainer from '../components/layouts/BoxedContainer';
import Button from '../components/layouts/Button';
import EventCard from '../components/event-card/EventCard';
import { getAllEvents } from '../services/getAllEvents';
import { fetchAllEvents } from '../services/fetchAllEvents';

async function getEvents() {
  try {
    const events = await fetchAllEvents();
    return events;
  } catch (error) {
    console.error('Error fetching events:', error);
    return [];
  }
}

export default function EventsBlock({ data }) {
  const { title, text, link } = data;
  const [events, setEvents] = useState([]);
  const graphQlEv = getAllEvents();
useEffect(() => {
  async function fetchData() {
    const fetchedEvents = isEmpty(graphQlEv) ? await getEvents() : graphQlEv;
    const filteredEvents = fetchedEvents.filter(event => {
      const currentDate = new Date();
      const eventEndDate = new Date(event.endDate);
      return eventEndDate >= currentDate;
    });
    setEvents(filteredEvents.slice(0, 4));
  }

  fetchData();
}, []);

  return (
    <section
      className="lg:pt-[136px] pt-[80px] lg:pb-[200px] pb-[80px] bg-bg-1 clip-top-right
      lg:-mt-[80px] -mt-[20px] z-5 relative overflow-hidden">
      <BoxedContainer className="boxed">
        <div className="flex flex-col xl:gap-y-[58px] lg:gap-y-[45px] gap-y-[30px]">
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 }}
            viewport={{ once: true }}
            className="flex 4xl:pl-[200px] 2xl:pl-[100px] lg:pl-[50px] items-center">
            <div className="flex flex-col xl:gap-y-[31px] lg:gap-y-[20px] gap-y-[15px]">
              {isEmpty(title) || (
                <h3
                  className="xl:text-[38px] lg:text-[30px] text-[28px] text-black leading-[23px]
                  font-roboto-condensed-bold uppercase">
                  {title}
                </h3>
              )}
              <div className="flex lg:flex-row flex-col xl:gap-x-[18px] gap-x-[35px] gap-y-[15px]">
                {isEmpty(text) || (
                  <p
                    className="2xl:text-base text-[15px] leading-7 text-primary lg:w-[570px]
                  font-roboto-regular">
                    {text}
                  </p>
                )}
                {isEmpty(link) || (
                  <Button
                    url={link.url}
                    ariaLabel={link.url}
                    label={link.name}
                    variant="primaryRed"
                    text="!w-fit-content h-[45px] px-[25px] whitespace-pre 2xl:mt-[10px]
                    lg:mt-[8px]"
                  />
                )}
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.5 }}
            viewport={{ once: true }}
            className="flex flex-col gap-y-[18px]">
            {isEmpty(events) || events.map((item, index) => <EventCard key={index} data={item} />)}
          </motion.div>
        </div>
      </BoxedContainer>
    </section>
  );
}
